import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription, map } from 'rxjs';
import { CrimeGunService } from 'src/app/services/crime-gun.service';

@Component({
  selector: 'ness-export-step-out',
  templateUrl: './export-step-out.component.html'
})
export class ExportStepOutComponent implements OnDestroy {
  numberOfSteps: number = 3;
  showConfirmStepOut: boolean = false;
  private _crimeGunStepSubscription: Subscription = null;

  private _crimeGunId: string;
  get crimeGunId(): string {
    return this._crimeGunId;
  }
  @Input() set crimeGunId(cgId: string) {
    this._crimeGunId = cgId;
  }

  private _crimeGunNumber: string;
  get crimeGunNumber(): string {
    return this._crimeGunNumber;
  }
  @Input() set crimeGunNumber(cg: string) {
    this._crimeGunNumber = cg;
  }

  @Output() closeCrimeGunStepOutView = new EventEmitter();

  constructor(private crimeGunService: CrimeGunService) { }

  ngOnDestroy() {
    if (this._crimeGunStepSubscription) {
      this._crimeGunStepSubscription.unsubscribe();
    }
  }

  onExportCSV() {
    this.showConfirmStepOut = true;
  }

  onConfirmSubmit(step: HTMLSelectElement): void {
    this.crimeGunService.getStepOutListCSV(this.crimeGunId, step.value).pipe(
      map((result) => {
        step.selectedIndex = 0;
        this.closeCrimeGunStepOutView.emit();
        this.showConfirmStepOut = false;
      }
      )).subscribe();
  }

  onCloseConfirmation(): void {
    this.showConfirmStepOut = false;
  }
}
